export const DEFAULT_LICENSES_MODAL_STATE = {
  toSuspendAutorenewal: [],
  toEnableAutorenewal: [],
  licensesSubscriptionCost: 0,
  licensesSubscriptionFullPeriodCost: 0,
  isViewMode: false,
};
